const formatLeadOrigin = (leadOrigin, lead) => {
  let formatted = "";

  if (leadOrigin === "qfs") {
    formatted = "HQ - QFS";
  } else if (leadOrigin === "liveAPI") {
    formatted = "Live API";
  } else if (leadOrigin === "phoneCall") {
    formatted = "Phone Call";
  } else if (leadOrigin === "flightDeckInternal") {
    formatted = "HQ - Internal";
  } else if (leadOrigin === "flightDeckExternal") {
    formatted = "HQ - External";
  } else if (leadOrigin === "apiV3") {
    formatted = "Outside Org API";
  } else if (leadOrigin === "iosApp") {
    // CTF/FOW sub-types reflect actual bookings, not CTF-eligibility. FOW is
    // marked by top-level featuredOneWayId; CTF by `isCtfBooking`, derived
    // server-side from a linked Trip (origin "clickToFlyBooking"). The estimate's
    // clickToFlyResultId only means CTF-eligible, so it is intentionally ignored.
    if (lead?.featuredOneWayId) {
      formatted = "iOS App - FOW";
    } else if (lead?.isCtfBooking) {
      formatted = "iOS App - CTF";
    } else {
      formatted = "iOS App - Standard";
    }
  } else {
    formatted = "Unset";
  }

  return formatted;
};

export default formatLeadOrigin;
